module.exports = __webpack_public_path__ + "664f1388ea0073a4188eea8d4a41acbb.pdf";